/**
 * Budget Types - v13 Section 6.10
 *
 * Type definitions for LLM budget management.
 */
/**
 * Default budget config (v13 Section 6.10)
 */
export const DEFAULT_BUDGET_CONFIG = {
    monthlyBudgetUsd: 10,
    dailyBudgetUsd: 5,
    unknownRequestReserveUsd: 1,
    throttling: {
        warnAt: 50,
        downgradeAt: 80,
        deferAt: 95,
        blockAt: 100,
    },
};
